import moment from 'moment'
import Bugsnag from '../plugins/bugsnag'
import {params} from '../localData'

moment.parseTwoDigitYear = function (yearString) {
  var year = parseInt(yearString)
  return (year > 22 ? 1900 : 2000) + year
}

export const getFromLocal = keyName => {
  return localStorage.getItem(keyName)
}
export const setToLocalStorage = ({ key, value }) => {
  return localStorage.setItem(key, value)
}

export const getLocale = () => {
  let browserLocale = window.navigator.userLanguage || window.navigator.language
  return browserLocale.split('-')[0]
}

export const getRandomiseFlowDecision = percent => {
  let decisionStatus
  if (Math.random() < percent / 100) {
    decisionStatus = true
  } else {
    decisionStatus = false
  }
  return decisionStatus
}

export const setCookie = (cname, cvalue, exdays, isLiliDomain = false) => {
  var d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + `${isLiliDomain ? ';domain=.lili.co' : ''}` + ';path=/'
}

export const getCookie = cname => {
  var name = cname + '='
  try {
    var decodedCookie = decodeURIComponent(document.cookie)
  } catch (e) {
    return ''
  }
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export const isLocalStorage = () => {
  try {
    window.localStorage.setItem('storageTest', true)
    return true
  } catch (e) {
    return false
  }
}

export const uppercaseFirstLetter = data => {
  let value = data.charAt(0).toUpperCase() + data.slice(1)
  return value
}

export const formatDateToISO = date => {
  const [month, day, year] = date.split('/')

  if (date.includes('-')) {
    return date
  }

  return `${year}-${month}-${day}`
}

export const isFromLiliApp = () => {
  let origins = ['Lili', 'liliapp']
  let status = false
  origins.map(origin => {
    if (navigator.userAgent.toLowerCase().includes(origin.toLowerCase())) {
      status = true
    }
  })
  return status
}

export const getDeviceType = () => {
  let type
  if (
    !!navigator.userAgent &&
    /iPad|iPhone|iPod|MacIntel/.test(navigator.userAgent)
  ) {
    type = 'ios'
  } else if (
    !!navigator.userAgent &&
    /android|Android/i.test(navigator.userAgent)
  ) {
    type = 'android'
  } else {
    type = 'unknown'
  }
  return type
}

export const hash = async string => {
  try {
    const utf8 = new TextEncoder().encode(string)
    const hashBuffer = await crypto.subtle.digest('SHA-256', utf8)
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    const hashHex = hashArray
      .map(bytes => bytes.toString(16).padStart(2, '0'))
      .join('')
    return hashHex
  } catch (err) {
    Bugsnag.notify('Hash exception: ', JSON.stringify(err))
  }
}
export const decodeURI = (data, rounds) => {
  let decodeRounds = rounds
  let decodedData = data
  try {
    for (let i = 1; i <= decodeRounds; i++) {
      decodedData = decodeURIComponent(decodedData)
    }
    return decodedData
  } catch (error) {
    console.log(error)
    return data
  }
}

export const updateCustomerStep = async (store, step, accessToken, customerId) => {
  if (!customerId || !accessToken) {
    return
  }
  try {
    await store.dispatch('customer/updateCustomer', {
      method: 'post',
      endPoint: `v3/secureonboarding/partner/user/${customerId}/step`,
      data: {
        step,
        version: params.stepVersion
      },
      header: {
        headerName: params.httpHeaders.auth,
        headerValue: `lili ${accessToken}`
      }
    })
  } catch (error) {
    console.error('Error updating customer step:', error)
  }
}

export const scrollToTop = (selector) => {
  document.querySelector(`${selector}`).scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  })
}

export const scrollIntoView = (el, behavior = 'smooth') => {
  el.scrollIntoView({
    behavior
  })
}

export const findKeyByValue = (fieldNameSectionMap, fieldName) => {
  for (const [key, val] of Object.entries(fieldNameSectionMap)) {
    if (val.includes(fieldName)) return key
  }
}

export const getSortedChildren = ($children) => {
  const children = $children

  // Sort the children based on their DOM position
  children.sort((a, b) => {
    // compareDocumentPosition returns a bitmask that describes the position of two nodes relative to each other.
    // Node.DOCUMENT_POSITION_FOLLOWING is a constant with a value of 4, which indicates that the first node
    // (a.$el in this case) comes before the second node (b.$el) in the document.
    // The bitwise AND operation (&) is used to check if the first node precedes the second in the DOM.
    return a.$el.compareDocumentPosition(b.$el) &
      Node.DOCUMENT_POSITION_FOLLOWING
      ? -1
      : 1
  })

  return children
}

export const getMaxUboPercentLeft = (customerData) => {
  const ownerPercent = Number(customerData.ownershipPercent)
  let sumOfOwnersPercent = 0
  customerData.businessOwners.forEach(owner => {
    if (owner.email !== customerData.email) {
      sumOfOwnersPercent += owner.ownershipPercent
    }
  })
  return 100 - (ownerPercent + sumOfOwnersPercent)
}

export const isUndefinedOrNull = (val) => val === undefined || val === null



// WEBPACK FOOTER //
// ./src/services/UtilService.js